import {createSpacing} from '@mui/system';
import {createTheme} from '@mui/material/styles';
import {Queries} from '../../GQL/GQLConstants';
import {gqlCall, GQLType} from '../../GQL/utils';
import {globalConfig} from '../../Config/config';

const getGlobal = async () => {
  const tenant_identity = globalConfig._config.client.CStenantID;
  const lang = globalConfig._config.client.CSlang;
  const {DELIVERY_TOKEN, APIKEY, ENV, URL} = globalConfig._config.ContentStack;

  try {
    const {
      data: {
        all_ast_global: {items: branding},
      },
    } = await gqlCall(
      GQLType.QUERY,
      Queries.GET_BRANDING_DATA,
      {
        tenant_identity: tenant_identity,
        locale: lang,
      },
      {access_token: DELIVERY_TOKEN},
      `${URL}${APIKEY}?environment=${ENV}`,
      true,
    );

    const {fonts, palette, spacingVariable, configurations} =
      branding[0].branding_reloadedConnection.edges[0].node;
    const navigationTabs = branding[0].navigation_tab_barConnection.edges[0].node.tab;
    const navigationTabsIframe = branding[0].navigation_tab_barConnection.edges[0].node.iframe_tab;
    const CSTheme = configurations.theme_referenceConnection.edges[0].node.theme;
    const header = branding[0].headerConnection.edges[0].node;
    const dateFormat = configurations.date_notationConnection.edges[0].node.format;
    return {
      fonts,
      palette,
      spacingVariable,
      CSTheme,
      navigationTabs,
      navigationTabsIframe,
      header,
      dateFormat,
    };
  } catch (error) {
    return {error};
  }
};

const setGlobal = async () => {
  try {
    const {
      fonts,
      CSTheme,
      spacingVariable,
      palette,
      navigationTabs,
      navigationTabsIframe,
      header,
      dateFormat,
    } = await getGlobal();

    const regular = {
      '@font-face': {
        fontFamily: 'regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: `url(${fonts.regularConnection.edges[0].node.url}) format('truetype'), local('OpenSans-regular'), local('OpenSans')
			  `,
      },
    };

    const bold = {
      '@font-face': {
        fontFamily: 'bold',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: `url(${fonts.boldConnection.edges[0].node.url}) format('truetype'),
				local('OpenSans-Bold'),
				local('OpenSans-Bold')
			  `,
      },
    };
    const semiBold = {
      '@font-face': {
        fontFamily: 'semi-bold',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: `url(${fonts.semiboldConnection.edges[0].node.url}) format('truetype'), local('OpenSans-SemiBold'), local('OpenSans-Bold')
		`,
      },
    };

    const headLineRegular = {
      '@font-face': {
        fontFamily: 'headline-regular',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: `url(${fonts.headline_regularConnection.edges[0].node.url}) format('truetype'), local('OpenSans-SemiBold'), local('OpenSans-Bold')
			  `,
      },
    };

    const headLineBold = {
      '@font-face': {
        fontFamily: 'headline-bold',
        fontStyle: 'normal',
        fontWeight: 'normal',
        src: `url(${fonts.headline_boldConnection.edges[0].node.url}) format('truetype'), local('OpenSans-SemiBold'), local('OpenSans-Bold')
			  `,
      },
    };

    const muiTheme: any = createTheme({...CSTheme});

    muiTheme.palette = palette;
    if (muiTheme?.components?.MuiCssBaseline) {
      muiTheme.components.MuiCssBaseline.styleOverrides = [
        regular,
        headLineBold,
        bold,
        semiBold,
        headLineRegular,
      ];
    }

    muiTheme['spacing'] = createSpacing((factor) => `${spacingVariable * factor}rem`);

    const finalTheme: any = createTheme(muiTheme);

    return {finalTheme, navigationTabs, navigationTabsIframe, header, dateFormat};
  } catch (error) {
    return {error};
  }
};

export {setGlobal};
